import { Stack, Typography } from "@mui/material";

export const NewBlock = () => {
  return (
    <Stack
      sx={{ padding: "0 4px", backgroundColor: "#FE8836", borderRadius: "4px" }}
    >
      <Typography
        sx={{
          fontSize: "10px",
          lineHeight: "16px",
          fontWeight: 500,
          color: "#FFFFFF",
        }}
      >
        New
      </Typography>
    </Stack>
  );
};
